import { IDashboardState } from '@/modules/dashboard/store/state';
import { MutationTree } from 'vuex';
import * as MT from './mutationsTypes';
import Organisation from '@/models/Organisation';
import OrganisationType from '@/models/OrganisationType';
import User from '@/models/User';
import { IFundState } from '@/modules/fund/store/state';
import { Currency } from '@/modules/fund/types';
/*--------------------------------------------------/
 * Dashboard Mutations
 *--------------------------------------------------*/
export const DashboardMutations: IDashboardMutations = {
  [MT.SET_ORGANISATIONS]: (
    state: IDashboardState,
    organisations: Organisation[]
  ) => (state.organisations = organisations),
  [MT.SET_ORGANISATION_TYPES]: (
    state: IDashboardState,
    organisationTypes: OrganisationType[]
  ) => (state.organisationTypes = organisationTypes),
  [MT.SET_SUPER_ACCESS_ROLES]: (state: IDashboardState, roles: string[]) =>
    (state.superAccessRoles = roles),
  [MT.SET_CURRENT_USER]: (state: IDashboardState, user: User) =>
    (state.currentUser = user),
  [MT.SET_CURRENCIES]: (state: IDashboardState, currencies: Currency[]) =>
    (state.currencies = currencies)
};

/*--------------------------------------------------/
 * Dashboard Mutations Tree Interface
 *--------------------------------------------------*/
export interface IDashboardMutations extends MutationTree<IDashboardState> {
  [MT.SET_ORGANISATIONS](
    state: IDashboardState,
    organisations: Organisation[]
  ): void;
  [MT.SET_ORGANISATION_TYPES](
    state: IDashboardState,
    organisationTypes: OrganisationType[]
  ): void;
  [MT.SET_SUPER_ACCESS_ROLES](state: IDashboardState, role: string[]): void;
  [MT.SET_CURRENT_USER](state: IDashboardState, user: User): void;
  [MT.SET_CURRENCIES](state: IDashboardState, currencies: Currency[]): void;
}
